export default __webpack_public_path__ + "static/media/xeonide.764e5e9c.png";